/**
 * Offene Provision der Agentur beim Creator in der Auszahlungsliste (SICHT-AGENTUR-GELD-11): Die Summe gilt je Creator und
 * Währung, nicht je Beleg. Sie steht deshalb nur an der ersten Zeile des Creators (in der Reihenfolge der Liste), mit den
 * Rechnungen, aus denen sie besteht; die übrigen Zeilen desselben Creators bekommen keinen Hinweis.
 */
export interface ClaimRef { id: string; number: string | null; open_cents: number }
export interface ClaimRow { invoice_id: string; talent_id: string; currency: string; claims_cents?: number; claims?: ClaimRef[] | null }
export interface ClaimNote { cents: number; currency: string; claims: ClaimRef[]; rows: number }

export function provisionHinweise(list: readonly ClaimRow[]): Map<string, ClaimNote> {
  const out = new Map<string, ClaimNote>();
  const seen = new Map<string, ClaimNote>();
  for (const c of list) {
    if ((c.claims_cents ?? 0) <= 0) continue;
    const key = `${c.talent_id}|${c.currency}`;
    const first = seen.get(key);
    if (first) {
      first.rows += 1;
      continue;
    }
    const note: ClaimNote = { cents: c.claims_cents!, currency: c.currency, claims: c.claims ?? [], rows: 1 };
    seen.set(key, note);
    out.set(c.invoice_id, note);
  }
  return out;
}
